import { _showAppLogs } from "../contexts/LogContext";
import { grts, responseReducers } from "./reducerHelpers/dispatchProps";

export const rts = {
  handleInit: "handleInit",
  addLog: "addLog",
  clearLogs: "clearLogs",
  setConsoleLog: 'setConsoleLog',
  ...grts,
};

export const logInitialState = (initState) => {
  return {
    ...initState,
    logs: [],
    maxLogs: 200,
  };
};

export const logReducer = (state, action) => {
  const { type } = action;

  switch (type) {
    case rts.handleInit:
      return { ...state };

    case rts.addLog: {
      const newLog = {
        id: Date.now(),
        message: action.message,
        time: new Date().toLocaleTimeString(),
      };

      const updatedLogs = [newLog, ...state.logs].slice(0, state.maxLogs);
      return { ...state, logs: updatedLogs };
    }

    case rts.clearLogs:
      return { ...state, logs: [] };

    case rts.updateSuccess:
    case rts.updateSuccessAlt:
    case rts.updateError:
      return responseReducers(state, action, { questionProps: null });

    default:
      return { ...state };
  }
};

export const logHandlers = (dispatch) => {

  return {
    handleInit: () => {
      dispatch({ type: rts.handleInit, dispatch });
    },

    addLog: (message, ...rest) => {
      const formatted =
        typeof message === "string"
          ? message
          : JSON.stringify(message, null, 2);

      // Optional: also print to console
      if (_showAppLogs.logReducer && (process.env.NODE_ENV === "development" || process.env.NODE_ENV === "dev")) {
        console.group('LOG')
        console.log(formatted, ...rest);
        console.groupEnd()
      }

      dispatch({ type: rts.addLog, dispatch, message: formatted });
    },

    clearLogs: () => {
      dispatch({ type: rts.clearLogs, dispatch });
    },
  };
};
